import { LOGIN_SUCCESS, LOGOUT, UPDATE_PROFILE, REQUEST_FORGOT_PASSWORD } from '../action/AuthAction';

const initialState = {
  isAuthenticated: false,
  token: null as string | null,
  profile: null as any | null,
  forgotPassword: {
    sessionId: '',
    email: '',
    code: '',
    newPassword: ''
  }
};

const authReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case LOGIN_SUCCESS:
      return {
        ...state,
        isAuthenticated: true,
        token: action.payload.token,
        profile: action.payload.profile,
      };
    
    case UPDATE_PROFILE:
      return {
        ...state,
        profile: {
          ...(state.profile || {}),
          data: {
            ...(state.profile?.data || {}),
            ...action.payload,
          }
        },
      };
    
    case LOGOUT:
      return initialState;
    
    case REQUEST_FORGOT_PASSWORD:
      return {
        ...state,
        forgotPassword: {
          ...state.forgotPassword,
          sessionId: action.payload.sessionId,
          email: action.payload.email,
        }
      };    
    
    default:
      return state;
  }
};

export default authReducer;